import Modal from '../Modal/Modal';
import stylez from './SuccessDialogue.module.css';

const SuccessDialogue = ({ show, msg,handleClose }) => {
  return (
    <Modal show={show}>
      <div className={stylez.successContainer}>
        <div className={stylez.crossIcon} onClick={handleClose}>x</div>
        <div>{msg}</div>
      </div>
    </Modal>
  );
};
export default SuccessDialogue;
